import http from './http';

/**
 * Obtiene todas las imágenes de splash disponibles si esta adjunto al rol.
 */
export async function listSplashImages() {
  const res = await http.get('/splash/image');
  return res.data?.data ?? res.data ?? [];
}

/**
 * Sube una nueva imagen de splash.
 */
export async function uploadSplashImage(file, role) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('role', role);
//   if (typeof order !== 'undefined' && order !== null) {
//     formData.append('order', order);
//   }

  const res = await http.post(`/splash/image`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return res.data?.data ?? res.data;
}

/**
 * Elimina un video de splash por ID.
 */
export async function deleteSplashImage(id) {
  const res = await http.delete(`/splash/${id}/image`);
  return res.data?.data ?? res.data;
}


